module.exports = __webpack_public_path__ + "img/icon_3.47e0478f.svg";